<template>
    <div class="orderList_table">
        <div class="myorder_table" v-for="o in orderList" :key="o.id">
            <div class="myorder_table_one personal_order_header_msg">
                <div>
                    <span>{{o.createTime|moment('YYYY-MM-DD')}}</span>
                    <router-link :to="{path:'/personalDetail/orderDetail?orderId=' + o.id}"><span class="strokeDiv">订单号：{{o.orderCode}}</span></router-link>
                    <span>仓库：{{o.warehouseName}}</span>
                </div>
                <div>
                    <template v-for="item in orerStatuses">
                        <span class="goDeliveryNote" :key="item.code + 'sta'" v-if="o.status >= 20 && item.code == o.status" @click="goDeliveryNote(o.orderCode)">查看送货单</span>
                    </template>
                    <span>订单状态：<template v-for="item in orerStatuses"><span :key="item.code" v-if="item.code == o.status">{{item.description}}</span></template></span>
                    <span class="backGoods" style="margin-right:40px" v-if="isCanReturned(o.orderItemDtos)">
                        <router-link :to="{path:'/personalDetail/returnGoods?orderId=' + o.id}">退货/售后</router-link>
                    </span>
                    <span class="backGoods">
                        <router-link :to="{path:'/personalDetail/orderDetail?orderId=' + o.id}">查看详情</router-link>
                    </span>
                </div>
            </div>
            <div class="myorder_table_two personal_order_header_msg">
                <div style="color:#333333">
                    <span>收货人：{{o.contact}}</span>
                    <span>联系电话：{{o.mobile}}</span>
                    <span>收货地址：{{o.provinceName}}{{o.cityName}}{{o.areaName}}{{o.detailAddress}}</span>
                </div>
                <div style="color:#E1251B">总计金额：<span class="personal_order_header_amount" style="font-size:13px">￥{{o.orderAmount}}</span></div>
            </div>
            <div class="myorder_table_three">
                <ul>
                    <template v-for="(oi, index) in o.orderItemDtos">
                        <li :key="oi.goodsId + '-' + index" v-if="oi.goodsId != 1">
                            <goods-info :goods="oi" widthValue="339px" />
                            <div class="table_list_msg_03 personal_order_content_msg">￥{{oi.price}}</div>
                            <div class="table_list_msg_03 personal_order_content_msg">{{oi.num}}{{oi.saleUnitName}}</div>
                            <div class="table_list_msg_03 personal_order_content_msg">
                                <el-tooltip class="item" effect="light" placement="bottom" offset="0">
                                    <div slot="content" style="max-width:500px">{{oi.customerRemark}}</div>
                                    <span class="order_remark">{{oi.customerRemark}}</span>
                                </el-tooltip>
                            </div>
                            <div class="table_list_msg_03 personal_order_content_msg">{{oi.deliveryNum}}{{oi.saleUnitName}}</div>
                            <div class="table_all_price personal_order_content_msg">￥{{oi.amount}}</div>
                            <!-- <div class="table_pay_status">月结</div> -->
                            <!-- <div class="table_shipment_status">已发货</div> -->
                            <div class="personal_order_content_msg table_operation" v-if="oi.deliveryNum - oi.returnedNum > 0 && o.orderType != 5">
                                <router-link :to="{path:'/personalDetail/returnGoods?mallGoodsWarehouseId='+oi.mallGoodsWarehouseId+'&orderId='+o.id}">申请退货</router-link>
                            </div>
                            <img class="sample_tips" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/sample_tips.png" v-if="o.orderType == 5" alt="">
                        </li>
                    </template>
                </ul>
                <div class="table_operations" v-if="(o.status == 1 || (o.status == 5 && o.payType == 3))">
                    <div v-if="o.payType != 3">
                        <span>
                            <el-link :underline="false" type="warning" @click="payOrder(o)">立即支付</el-link>
                        </span>
                    </div>
                    <div class="color">
                        <el-link :underline="false" type="danger" @click="cancelOrder(o)">取消订单</el-link>
                    </div>
                </div>
                <div class="table_operations" v-if="o.status==100">
                    <div>
                        <span>
                            <el-link :underline="false" type="warning" @click="confirmOrder(o)">立即确定</el-link>
                        </span>
                    </div>
                    <div class="color">
                        <el-link :underline="false" type="danger" @click="cancelOrder(o)">取消订单</el-link>
                    </div>
                </div>
            </div>
            <div class="myorder_table_four">
                <template v-for="(oi, index) in o.orderItemDtos">
                    <div class="myorder_table_four_amount" :key="oi.goodsId + '-' + index" v-if="oi.goodsId == 1">
                        <span>运费</span>
                        <span>￥{{oi.amount}}</span>
                    </div>
                </template>
                
                <div class="personal_order_remarks" >
                    <span class="width">备注：</span>
                    <el-tooltip class="item" effect="light" placement="bottom">
                        <div slot="content" style="max-width:500px">{{o.customerRemark}}</div>
                        <span class="text">{{o.customerRemark}}</span>
                    </el-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    getOrerStatusesData,
    auditNotpassOrderData,
    rejectOrder,
} from "@/api/customer/orderApi";
import "@/assets/css/personalTable.css";
import GoodsInfo from "@/components/goods/goodsInfo.vue";
export default {
    components: { GoodsInfo },
    data() {
        return {
            isMain: this.$store.state.isMian,
            orerStatuses: [],
            customerRemark: "",
        };
    },
    props: {
        orderList: [],
    },
    created: function () {
        this.getOrerStatuses();
    },
    methods: {
        getOrerStatuses: function () {
            getOrerStatusesData().then((res) => {
                this.orerStatuses = res.data;
            });
        },
        rejectOrder(o) {
            if (o.customerRemark) {
                this.$confirm("确定要驳回此订单？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true,
                })
                    .then(() => {
                        this.$emit("rejectOrder", o, o.customerRemark);
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } else {
                this.$confirm("请填写订单备注？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true,
                });
            }
        },
        confirmOrder(o) {
            this.$confirm("确定要确定此订单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    this.$emit("confirmOrder", o);
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        payOrder: function (o) {
            if (o.payType == 1) {
                this.$router.push({
                    name: "alipay",
                    params: {
                        orderCode: o.orderCode,
                        orderAmount: o.orderAmount,
                        payType: o.payType,
                    },
                });
            }
            if (o.payType == 2) {
                this.$router.push({
                    name: "onlinePay",
                    params: {
                        orderCode: o.orderCode,
                        orderAmount: o.orderAmount,
                        payType: o.payType,
                    },
                });
            }
        },
        cancelOrder: function (order) {
            auditNotpassOrderData(order.id).then((res) => {
                if (res.success) {
                    order.status = -1;
                    this.$alert("订单已取消！", {
                        confirmButtonText: "确定",
                    });
                } else {
                    this.$alert(res.msg, {
                        confirmButtonText: "确定",
                    });
                }
            });
        },
        goodDetail: function (mallGoodsWarehouseId) {
            this.$router.push({
                path: "/productDetail",
                query: { mallGoodsWarehouseId: mallGoodsWarehouseId },
            });
        },
        goDeliveryNote: function (id) {
            this.$router.push({
                path: "/personal/DeliveryList",
                query: { orderCode: id },
            });
        },
        isCanReturned: function (orderItemList) {
            for (let i = 0; i < orderItemList.length; i++) {
                const element = orderItemList[i];
                if (element.goodsId == 1) {
                    continue;
                }
                if (
                    element.deliveryNum -
                        element.applyReturnedNum -
                        element.returnedNum >
                    0
                ) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>
<style scoped>
.el-link {
    font-size: 13px !important;
}
.el-link--danger {
    color: #333;
}
.el-link--warning {
    color: #e1251b;
}
.width {
    display: inline-block;
    width: 50px;
}
.text {
    width: 494px;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    overflow: hidden;
}
.order_remark {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 20px;
    overflow: hidden;
    word-break: break-all;
}
.sample_tips {
    width: 70px;
    height: 34px;
    position: absolute;
    right: -37px;
}
.goDeliveryNote {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/personal/order/orderList.vue